import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const createPotentialChannels = async (data) => {
  return await axios.post('potential-sensors/channels', data)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default createPotentialChannels;